import { Field, useFormikContext } from 'formik';
import React from 'react';
import {
  DropdownWithValidation,
  InputTextWithValidationMessage,
  TextAreaWithValidation,
} from '../../../components/prime-formik';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import PayedByInput from './PayedByInput';
import NumberOfEmployeesInput from './NumberOfEmployeesInput';

const messages = defineMessages({
  fullName: { id: 'attrs.owner.fullName', defaultMessage: "Owner's full name" },
  email: { id: 'attrs.owner.email', defaultMessage: "Owner's e-mail" },
  plan: { id: 'attrs.credit-plan', defaultMessage: 'Account Credit Plan' },
  preferredLanguage: { id: 'attrs.preferred.language', defaultMessage: 'Preferred language' },
  message: { id: 'attrs.owner.message', defaultMessage: 'Message to Owner: ' },
});

const AccountStep = ({ isCurrentStep, account, languages, availableNumbersOfEmployees }) => {
  const { formatMessage } = useIntl();
  const {
    cldr: { localeDisplayName },
  } = useSelector((state) => state.i18n);

  const { setFieldValue } = useFormikContext();

  const languageOptions = languages.map((locale) => ({
    value: locale,
    label: localeDisplayName(locale),
  }));

  if (!isCurrentStep) {
    return null;
  }

  return (
    <div className="p-grid p-fluid">
      <PayedByInput parentAccountType={account.type} />
      <NumberOfEmployeesInput availableNumbersOfEmployees={availableNumbersOfEmployees} />
      <div className="p-col-12">
        <Field
          id="fullName"
          name="fullName"
          labelText={formatMessage(messages.fullName)}
          component={InputTextWithValidationMessage}
        />
      </div>
      <div className="p-col-12">
        <Field
          id="email"
          name="email"
          type="email"
          labelText={formatMessage(messages.email)}
          component={InputTextWithValidationMessage}
        />
      </div>
      <div className="p-col-12">
        <label htmlFor="preferredLanguage">{formatMessage(messages.preferredLanguage)}</label>
        <Field
          id="preferredLanguage"
          name="preferredLanguage"
          labelText={formatMessage(messages.preferredLanguage)}
          component={DropdownWithValidation}
          filter
          filterBy="label"
          options={languageOptions}
          onChange={(e) => {
            setFieldValue('preferredLanguage', e.target.value);
          }}
        />
      </div>
      <div className="p-col-12">
        <label htmlFor="inviteMessage">{formatMessage(messages.message)}</label>
        <Field id="inviteMessage" name="inviteMessage" component={TextAreaWithValidation} rows={6} />
      </div>
      <div className="p-col-12">
        <FormattedMessage
          id="accounts.add-client.steps.client.details"
          defaultMessage="The new account will be created under {partnerName}"
          values={{
            partnerName: <strong>{account.displayName}</strong>,
          }}
          tagName="p"
        />
      </div>
    </div>
  );
};

export default AccountStep;
